<template>
  <v-card flat>
    <v-row
      no-gutters
      class="px-4"
    >
      <v-col
        cols="12"
        class="px-3"
        :sm="6"
        :md="3"
      >
        <WBDRegionListSelectorFilter
          :remote-list="[]"
          @onRegionListSelectorFilterChange="onRegionListSelectorFilterChange"
        />
      </v-col>
      <v-col
        cols="12"
        class="px-3"
        :sm="6"
        :md="4"
      >
        <WBDOrganizationSelectorFilter
          :remote-list="remoteList"
          :selected-option-value="''"
          @onOrganizationListSelectorFilterChange="onOrganizationListSelectorFilterChange"
        />
      </v-col>
      <!--      to hide-->
      <v-col
        v-if="loading === 10000"
        cols="12"
        class="px-3"
        :sm="6"
        :md="4"
      >
        <WBDOfficeSelectorFilter
          :remote-list="[]"
          :label="'Поиск объектов'"
          :remote-selected-list-list="''"
          @onOfficeSelectorFilterChange="onOfficeSelectorFilterChange"
        />
      </v-col>
      <v-col
        cols="12"
        class="px-3"
        :sm="6"
        :md="3"
      >
        <WBDProfessionSelectorFilter
          :remote-list="[]"
          :label="'Основная обязанность'"
          :remote-selected-list-list="''"
          @onSelectedProfessionValueChange="onSelectedProfessionValueChange"
        />
      </v-col>
      <v-col
        cols="12"
        class="px-3"
        :sm="6"
        :md="3"
      >
        <WBDCitySelectorFilter
          :filtered-laborer-list="''"
          :remote-list="[]"
          @onCitySelectorFilterChange="onCitySelectorFilterChange"
        />
      </v-col>
      <v-col
        cols="12"
        class="px-3"
        :sm="12"
        :md="8"
      >
        <WBSearchQueryFilter
          :remote-value="''"
          :label="'Поиск по названию'"
          @onSearchQueryFilterChange="onSearchQueryFilterChange"
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>

import WBSearchQueryFilter from '@/components/common/filter/search-query-filter'
import WBDRegionListSelectorFilter from '@/components/common/filter/region-selector-filter'
import WBDOrganizationSelectorFilter from '@/components/common/filter/organization-selector-filter'
import WBDOfficeSelectorFilter from '@/components/common/filter/office-selector-filter'
import WBDProfessionSelectorFilter from '@/components/common/filter/profession-selector-filter'
import WBDCitySelectorFilter from '@/components/common/filter/city-search-filter'

export default {
  name: 'WBDVacancyRatePageListFilter',
  components: {
    WBDCitySelectorFilter,
    WBSearchQueryFilter,
    WBDProfessionSelectorFilter,
    WBDRegionListSelectorFilter,
    WBDOrganizationSelectorFilter,
    WBDOfficeSelectorFilter,
  },
  props: {
    vacancyRateListFilterSet: {
      type: Object,
      default: () => ({
        searchQuery: null,
        region: null,
        office: null,
        organization: null,
        profession: null,
        locality: null,
        vacancy: null,
      })
    }
  },
  data: () => ({
    searchQuery: '',
    remoteList: [],
    loading: true,
  }),
  computed: {
  },
  watch: {
    vacancyRateListFilterSet: {
      handler (val) {
        for (const [key, value] of Object.entries(val)) {
          if (this.vacancyRateListFilterSet[key] !== value) {
            this.vacancyRateListFilterSet[key] = value
          }
        }
      },
      deep: true,
    },
  },
  created () {
    this.eventsBus.$on(this.eventNames.VACANCY_RATE_LIST_FILTER_RESET, () => {
      this.resetAll()
      this.resetAll()
    })
  },
  methods: {
    onNotificationStatusSelectorFilterChange (data) {
      this.vacancyRateListFilterSet.status = data
    },
    resetAll () {
      this.eventsBus.$emit(this.eventNames.SEARCH_FILTER_RESET)
      this.eventsBus.$emit(this.eventNames.ORG_LIST_FILTER_RESET)
      this.eventsBus.$emit(this.eventNames.REGION_LIST_FILTER_RESET)
      this.eventsBus.$emit(this.eventNames.OFFICE_LIST_FILTER_RESET)
      this.eventsBus.$emit(this.eventNames.PROFESSION_LIST_FILTER_RESET)
      this.eventsBus.$emit(this.eventNames.CITY_SEARCH_FILTER_RESET)
    },
    onSearchQueryFilterChange (data) {
      this.vacancyRateListFilterSet.searchQuery = data
    },
    onOrganizationListSelectorFilterChange (data) {
      this.vacancyRateListFilterSet.organization = data
    },
    onRegionListSelectorFilterChange (data) {
      this.vacancyRateListFilterSet.region = data
    },
    onOfficeSelectorFilterChange (data) {
      this.vacancyRateListFilterSet.office = data
    },
    onSelectedProfessionValueChange (data) {
      this.vacancyRateListFilterSet.profession = data
    },
    onCitySelectorFilterChange (data) {
      this.vacancyRateListFilterSet.locality = data
    },
  },
}
</script>
<style lang="scss" scoped>
.office-item {
  cursor: pointer;
}
</style>
